/**
 * @fileName      shareData
 * @dateTime      2021/7/6 9:59:48
 * @author        Millionfor <millionfor@gmail.com>
 * @description   share data
 */

import { initGlobalState } from '../../../cdn/libs/qiankun/es/index.js'

const store = {}

class InnerCtor {
  constructor (self) {
    this.$this = self
    this.microAppStateActions = initGlobalState(store)
    // 注册共享数据监听
    this.microAppStateActions && this.microAppStateActions.onGlobalStateChange(({ fnCode, data }) => {
      switch (fnCode) {
        case 'on-to-path':
          this.$onToPath(data)
          break
        default:
      }
    })
  }

  $onToPath ({ value }) {
    this.$this.$router.push(value)
  }
}

export default InnerCtor



// WEBPACK FOOTER //
// ./src/js/module/singleSpa/shareData.js